import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { ApiServiceBase, API_NAMES } from '../api';

@Injectable({ providedIn: 'root' })
export class PasswordService extends ApiServiceBase {
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.identity);
  }

  forgot(model: any) {
    return this.http.post(this._url('/forgot-password'), model);
  }

  reset(model: any) {
    return this.http.post(this._url('/reset-password'), model);
  }
  resetFromUserForm(model: any) {
    return this.http.post(this._url('/reset-password-user-form'), model);
  }

  change(model: any){
    return this.http.post(this._url('/change-password'), model);
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/accounts${v}`);
  }
}
